import { IChannel } from '@r1-frontend/ui-react/components/Channels/types';

import * as ST from './styled';

export interface IChannelsListProps {
    channels: IChannel[],
    channelsFiltersIsApply: boolean,
    inactiveLink?: boolean,
}

const ChannelsList = ({
    channels = [],
    channelsFiltersIsApply,
    inactiveLink = false,
}: IChannelsListProps): JSX.Element => {
    return (
        <ST.Wrapper data-test='channels-list'>
            {
                channelsFiltersIsApply && !channels.length && (
                    <ST.ChannelText data-test='channels-list-notfound-msg'>
                        Канал, который вы ищете, не входит в данный тариф
                    </ST.ChannelText>
                )
            }
            <ST.List>
                {channels.map((channel) => {
                    return <ST.ChannelWithMargin
                        key={channel.channelId}
                        link={channel.channelInfo.url}
                        image={channel.channelInfo.logo}
                        title={channel.title}
                        inactiveLink={inactiveLink}
                        data-test='channels-list-channels'
                    />;
                })}
            </ST.List>
        </ST.Wrapper>
    );
};

export default ChannelsList;
